import { AISummary } from '@statsbomb/kitbag-ai-summary';
import { Card } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { useSearchParams } from 'react-router-dom';
import { playerIdAtom } from '@/atoms/player/player';
import { CardHeightWrapper } from '@/components/card/CardHeightWrapper';
import { NoTextLoader } from '@/components/contentState/NoTextLoader';
import { PLAYER_ID } from '@/consts/searchKeys';
import { useSummaryPlayerData } from '@/hooks/useSummaryPlayerData';

export const PlayerPreviewSummary = () => {
  const [searchParams] = useSearchParams();
  const urlPlayerId = searchParams.get(PLAYER_ID);
  const playerId = useAtomValue(playerIdAtom);

  // playerIdAtom is synced from the URL via useEffect in SetPlayerPreviewData, which fires
  // after paint. Show the spinner immediately when the URL changes, before the atom catches up.
  const isPlayerSyncing = playerId === null || String(playerId) !== urlPlayerId;
  const playerData = useSummaryPlayerData({ isPending: isPlayerSyncing });

  if (!urlPlayerId) return null;
  if (!playerData) return <NoTextLoader />;

  return (
    <div className="h-full max-md:h-[75vh] max-md:flex-none md:flex-1 md:min-h-0">
      <Card>
        <CardHeightWrapper>
          {/* Required structural layer: CardHeightWrapper targets [&>div] and [&>div>div] — do not remove */}
          <div>
            <AISummary key={playerData.playerId} playerData={playerData} />
          </div>
        </CardHeightWrapper>
      </Card>
    </div>
  );
};
